// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import VueCookies from 'vue-cookies';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faFile,
  faFilePdf,
  faFileWord,
  faFileImage,
  faFileExcel,
  faFileVideo,
  faFileArchive,
  faTimesCircle,
  faExclamationTriangle,
  faPencilAlt,
  faPen,
  faEye,
  faVideo,
  faArchive,
  faPlay,
  faImages,
  faChartBar,
  faInfoCircle,
  faTimes,
  faCog,
  faDesktop,
  faList,
  faThLarge,
  faCommentAlt,
  faCode,
  faPlusCircle,
  faPlus,
  faBars,
  faEnvelope,
  faLink,
  faClock,
  faEllipsisV,
  faSearch,
  faFilter,
  faCalendarAlt,
  faCheckCircle,
  faShareSquare,
  fas,
  faFileDownload,
  faTrash,
  faCheck,
  faPlayCircle,
  faArrowLeft,
  faObjectGroup,
} from '@fortawesome/free-solid-svg-icons';

import { far, faCopy } from '@fortawesome/free-regular-svg-icons';
import { fab, faChromecast } from '@fortawesome/free-brands-svg-icons';
import VueI18n from 'vue-i18n';
import i18n from './i18n/index';
import ckEditor from '@ckeditor/ckeditor5-vue';
import en from './i18n/en_US.js';
import fr from './i18n/fr_FR.js';
import 'typeface-roboto/index.css';
import './assets/scss/main.scss';

import App from './App';
import router from './router';
import store from './store/index';
import VueMoment from 'vue-moment';
import moment from 'moment';
import Toasted from 'vue-toasted';
export const bus = new Vue();
const urlParams = new URLSearchParams(window.location.search);
const color = urlParams.get('color') ? urlParams.get('color') : '#2096f8';
import './assets/scss/nprogress.scss';
import NProgress from 'nprogress';
import VueTimepicker from 'vue2-timepicker'
Vue.use(VueTimepicker);

window.eventHub = new Vue();

Vue.use(VueMoment, {
  moment,
});
Vue.use(ckEditor);
library.add(
  faPencilAlt,
  faEye,
  faVideo,
  faArchive,
  faPlay,
  faImages,
  faFile,
  faFilePdf,
  faFileWord,
  faFileImage,
  faFileExcel,
  faFileVideo,
  faFileArchive,
  faTimesCircle,
  faExclamationTriangle,
  faChartBar,
  faInfoCircle,
  faTimes,
  faCommentAlt,
  faCode,
  faPen,
  faCog,
  faDesktop,
  faList,
  faThLarge,
  faPlusCircle,
  faPlus,
  faBars,
  faEnvelope,
  faLink,
  faCopy,
  faClock,
  faEllipsisV,
  faSearch,
  faFilter,
  faCalendarAlt,
  faChromecast,
  fab,
  fas,
  far,
  faShareSquare,
  faFileDownload,
  faTrash,
  faCheck,
  faCheckCircle,
  faPlayCircle,
  faArrowLeft,
  faObjectGroup,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueCookies);
Vue.use(Toasted, {
  iconPack: 'custom-class',
});
Vue.use(NProgress);
let progress = document.querySelector(NProgress.settings.parent);
progress.setAttribute('style', '--primary-color:' + color);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueI18n);
Vue.config.productionTip = false;
VueCookies.config('7d');
let locale = 'fr';
i18n.locale = locale;
bus.$on('setFormLang', lang => {
  locale = lang;
  i18n.locale = locale;
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: `<App/>`,
});



// WEBPACK FOOTER //
// ./src/main.js